// The only place that does timecode maths. Frames are integers; text is HH:MM:SS:FF.
// ponytail: fixed 25 fps, Asset has no fps field; read it per asset once the API carries one.
export const FPS = 25;
/** "Unset" on the wire (RestoreWorker.EMPTY_TC); any other form makes the restore throw. */
export const WIRE_UNSET = "--:--:--";
/** "Unset" on screen. */
export const UNSET_TC = "--:--:--:--";

const TC_PATTERN = /^\s*(\d{1,2}):(\d{2}):(\d{2})(?:[:;](\d{2}))?\s*$/;

/** The frame on screen at a time; the epsilon keeps a frame's own start on that frame. */
export function toFrames(secs) {
  return Math.floor(secs * FPS + 1e-6);
}

export function framesToTc(frames) {
  const total = Math.max(0, Math.round(frames));
  const parts = [Math.floor(total / (FPS * 3600)), Math.floor(total / (FPS * 60)) % 60, Math.floor(total / FPS) % 60, total % FPS];
  return parts.map((part) => String(part).padStart(2, "0")).join(":");
}

export function toTc(secs) {
  return framesToTc(toFrames(secs));
}

/** Seconds for H:MM:SS, HH:MM:SS or either with :FF (or ;FF); null for anything else. */
export function parseTc(text) {
  const match = TC_PATTERN.exec(text || "");
  if (!match) return null;
  const [hours, minutes, seconds, frames] = [match[1], match[2], match[3], match[4] || "0"].map(Number);
  if (minutes > 59 || seconds > 59 || frames >= FPS) return null;
  return hours * 3600 + minutes * 60 + seconds + frames / FPS;
}

/** A stored timecode (8 or 11 characters, or the sentinel) as the 11 characters shown. */
export function displayTc(wire) {
  const secs = parseTc(wire);
  return secs == null ? UNSET_TC : toTc(secs);
}

/** The asset's source timecode start in frames; a missing or unreadable offset counts as 0. */
export function offsetFrames(asset) {
  const secs = parseTc(asset && asset.offset);
  return secs == null ? 0 : toFrames(secs);
}
